import type { ReactNode } from "react";

import clsx from "clsx";
import { Checkbox as AriaCheckbox } from "react-aria-components";
import { useController, useFormContext } from "react-hook-form";

import { SuccessIcon } from "../../../icons/success";

import styles from "./checkbox.module.css";

type CheckboxProps = {
	label: string;
	name: string;
	/** Fires after the field updates, with the new checked state. */
	onChange?: (isChecked: boolean) => void;
};

export function Checkbox({ label, name, onChange }: CheckboxProps): ReactNode {
	const { control } = useFormContext();
	const { field } = useController({ control, name });

	return (
		<AriaCheckbox
			className={styles.checkbox}
			isSelected={Boolean(field.value)}
			onChange={(isChecked) => {
				field.onChange(isChecked);
				onChange?.(isChecked);
			}}
		>
			<span aria-hidden className={styles.box}>
				<SuccessIcon className={styles.tick} />
			</span>
			<span className={clsx("body-2", styles.label)}>{label}</span>
		</AriaCheckbox>
	);
}
